<template>
    <div class="circle-arrow-container" :style="`--dasharray-gap: ${dashArrayGap}deg; --stroke-width: ${size * 0.11}px`">
        <svg :width="size" :height="size" :viewBox="`0 0 ${absoluteWidth + offset} ${absoluteHeight + offset}`" fill="none" preserveAspectRatio="xMidYMin">
            <circle 
                class="top-circle"
                :cx="size/2 + (offset / 2)" 
                :cy="size/2 + (offset / 2)" 
                :r="size/2"
                :stroke-width="size * 0.11" 
                :stroke-dasharray="`${dashArray} ${dashArray}`" 
                :stroke-dashoffset="dashOffset"
                fill="none" 
                :stroke="color"
            >
                <animate
                    class="animation-tag"
                    attributeName="stroke-dashoffset"
                    :from="dashArray"
                    :to="dashOffset"
                    dur=".75s"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines=".8 .1 .1 1"
                />
                <animate
                    class="animation-tag"
                    attributeName="stroke-width"
                    :from="0"
                    :to="size * 0.11"
                    dur=".75s"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines=".8 .1 .1 1"
                />
            </circle>
        
            <circle 
                class="bottom-circle"
                :cx="size/2 + (offset / 2)" 
                :cy="size/2 + (offset / 2)" 
                :r="size/2"
                :stroke-width="size * 0.11" 
                :stroke-dasharray="`${dashArray} ${dashArray}`" 
                :stroke-dashoffset="dashOffset"
                fill="none" 
                :stroke="color"
            >
                <animate
                    ref="placeholderAnimation"
                    class="animation-tag"
                    attributeName="stroke-dashoffset"
                    :from="dashArray"
                    :to="dashOffset"
                    dur=".75s"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines=".8 .1 .1 1"
                />
                <animate
                    class="animation-tag"
                    attributeName="stroke-width"
                    :from="0"
                    :to="size * 0.11"
                    dur=".75s"
                    calcMode="spline"
                    keyTimes="0; 1"
                    keySplines=".8 .1 .1 1"
                />
            </circle>
        </svg>

        <div class="top-arrow-container">
            <svg class="top-arrow" width="11" height="10" viewBox="0 0 12 11" fill="none">
                <path d="M1 4.62231L5.62231 9.24463L10.2446 4.62231" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="bottom-arrow-container">
            <svg class="bottom-arrow" width="11" height="10" viewBox="0 0 12 11" fill="none">
                <path d="M1 4.62231L5.62231 9.24463L10.2446 4.62231" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CircleArrows',
    props: {
        color: {
            type: String,
            default: 'white',
        },
        width: {
            type: [Number, String],
            default: 8,
        },
        height: {
            type: [Number, String],
            default: 9,
        },
    },
    data() {
        return {
        }
    },
    computed: {
        absoluteWidth() {
            return Number.parseFloat(this.width);
        },
        absoluteHeight() {
            return Number.parseFloat(this.height);
        },
        size() {
            return Math.max(Number.parseFloat(this.width), Number.parseFloat(this.height));
        },
        offset() {
            return this.size * 0.2
        },
        dashArray() {
            return 2 * (this.size/2) * Math.PI;
        },
        dashArrayGap() {
            return this.dashArray / 2.5
        },
        dashOffset() {
            return this.dashArray - this.dashArrayGap
        }
    },
};
</script>

<style lang="scss" scoped>

.circle-arrow-container {
    position: relative;
}

.top-circle {
    transform: rotate(calc(270deg - 45deg));
    transform-origin: center;
}

.bottom-circle {
    transform: rotate(calc(90deg - 45deg));
    transform-origin: center;
}

.arrow-path {
    position: absolute;
}

.top-arrow-container {
    position: absolute;
    inset: 0;
    transform: rotate(0deg);
    animation: rotate-arrow .75s cubic-bezier(.8,.1,0.08,1) forwards;

    .top-arrow {
        position: absolute;
        left: calc(var(--stroke-width) * -1.2);
        bottom: 6px;
        width: 10px;
        height: 10px;
        transform: rotate(180deg);
        animation: jump-in .75s ease forwards;
    }
}

.bottom-arrow-container {
    position: absolute;
    inset: 0;
    transform: rotate(var(--dasharray-gap) - 180deg);
    animation: rotate-arrow .75s cubic-bezier(.8,.1,0.08,1) forwards;

    .bottom-arrow {
        position: absolute;
        right: calc(var(--stroke-width) * -1.2);
        top: 6px;
        width: 10px;
        height: 10px;
        animation: jump-in .75s ease forwards;
    }
}

@keyframes rotate-arrow {
    to {
        rotate: 180deg;
    }
}
@keyframes jump-in {
    0% {
        opacity: 0;
        scale: 0;
    } 50% {
        opacity: 0;
    } 51% {
        opacity: 1;
    } 100% {
        opacity: 1;
        scale: 1;
    }
}
</style>
